import { render } from "./TouchpointsTableView.vue?vue&type=template&id=63dee975"
import script from "./TouchpointsTableView.vue?vue&type=script&lang=js"
export * from "./TouchpointsTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/TouchpointsTableView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63dee975"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63dee975', __exports__)) {
    api.reload('63dee975', __exports__)
  }
  
  module.hot.accept("./TouchpointsTableView.vue?vue&type=template&id=63dee975", () => {
    api.rerender('63dee975', render)
  })

}


export default __exports__